




























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore
} from "@root/lib/decorator";
import RefundChanngeLog from "@/components/pages/Order/ChangeLog.vue";

const common = namespace("common");
const scan = namespace("scan");

@Component({
  filters: {
    dNull(val) {
      return val || "-";
    }
  }
})
@pagination("getData", {
  pageSize: 50
})
@SearchbarControl()
@loading()
@IsMore(true)
export default class WtInspect extends Vue {
  @common.Action queryDataDictionaryListLang;
  @scan.Action querySupplierScanRecordInfo;
  @scan.Action getAttr;

  @scan.State patternList; // 花纹
  @common.State tyreBrandList;

  private dataList = [];
  private tyreBrandOptions = [];

  private tabLoading = false;
  private loading = false;
  private showTireDialog = false;

  private detailForm = {
    pattern: "",
    tyreBrand: ""
  };

  private pageHeaderData = {
    progress: "0%",
    state: 1,
    taskStartTime: "",
    taskEndTime: "",
    storeTag: "Impression"
  };

  private pageStatusStr = "";

  get dataListComputed() {
    return this.dataList;
  }
  get routerCode() {
    return (this.$route.query.code || "") as any;
  }
  reviewAc(row) {
    // 查看门店详情
    this.showTireDialog = true;
  }

  async created() {
    this.getOptionsDic();
    this.initData();
  }

  async getOptionsDic() {
    const res = await this.queryDataDictionaryListLang({
      statePath: "tyreBrandList",
      ddCode: "WT_BRAND"
    });
    this.tyreBrandOptions = res.map(({ label }) => ({ label, value: label }));
  }

  async initData() {
    this.loading = true;
    if (!this.routerCode) {
      this.$router.push({
        name: "inventoryFlow"
      });
      return;
    }
    await this.getData();
    await this.getAttrApi();
  }

  @loadingCatch
  async getData() {
    const { pageSize, currentPage: pageNum } = this as any;
    const pageInput = {
      pageSize,
      pageNum
    };

    const timeArr = (time, index) => {
      return time && time.length > 0 ? time[index] : "";
    };

    try {
      const { pattern, tyreBrand } = this.detailForm;
      let attachInput = {
        pattern,
        tyreBrand
      };
      const searchForm = {
        input: {
          recordCode: this.routerCode,
          tyreBrand,
          pattern
          // specifications: "",
          // rim: "",
          // orgCode: "",
          // tenantCode: ""
        },
        pageInput
      };
      let { total, list } = await this.querySupplierScanRecordInfo(searchForm);
      (this as any).total = total;
      this.dataList = list || [];
    } catch (err) {
      this.dataList = [];
      console.error(err);
      (this as any).total = 0;
    }
  }
  async getAttrApi() {
    await this.getAttr({
      codeList: ["_pattern"],
      orgCode: "default"
    });
  }
  arrStr2ArrObj(list) {
    return list.map(item => ({ value: item }));
  }
}
